const DateEditorComponent = () => {
    return null;
};

export default DateEditorComponent;
